import { Text } from "@dropbox/dig-components/typography";
import { memo } from "react";

import styles from "./ChatDiagnosticsViewer.module.css";

interface ChatDiagnosticsStringViewerProps {
  content: string;
}
export const ChatDiagnosticsStringViewer = memo(
  ({ content }: ChatDiagnosticsStringViewerProps) => {
    return (
      <Text monospace tagName="pre" className={styles.codeViewer} size="xsmall">
        {content}
      </Text>
    );
  },
);
ChatDiagnosticsStringViewer.displayName = "ChatDiagnosticsStringViewer";
